<ng-container>
  <!-- This span triggers the overlay and is its origin -->
  <div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    @if (inputControls?.iconTriggered === false || inputControls?.iconTriggered == null || inputControls?.iconTriggered === undefined) {
      <span
        (click)="toggleOvl()"
        class="no-ellipsis"
        [ngClass]="customSpanClass ?? {}">
        {{ getCommentText() }}
      </span>
    }
    <!-- Bind from button icon if iconTriggered -->
    @if (inputControls?.iconTriggered === true) {
      <button
        mat-icon-button
        matSuffix
        [matTooltip]="'Edit content'"
        (click)="toggleOvl()">
        <mat-icon class="icon-color-fix-orange">edit</mat-icon>
      </button>
    }
  </div>
  <!-- This template displays the overlay content and is connected to the span -->
  <ng-template cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="inputControls?.isOpenOverlay ?? false"
    [cdkConnectedOverlayHasBackdrop]="inputControls?.isOpenOverlay ?? false"
    (backdropClick)="backdropActions()"
    (attach)="fitTextAreaToContent()"
    [cdkConnectedOverlayOffsetY]="5">
    <textarea id={{inputControls?.textAreaId}}
      oninput='this.style.height = "";this.style.height = this.scrollHeight + 3 + "px"'
      style="max-height:250px"
      [(ngModel)]="comment"
      [maxlength]="inputControls?.maxCommentLength ?? 1000"
      [matTooltip]="inputControls?.isEditable ? getMaxLengthTooltipText() : ''"
    class="form-control"></textarea>
  </ng-template>
</ng-container>
